/**
 * @generated SignedSource<<1e37f758a1ad960b37a496a06f720a24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventCapacityType = "ATTENDEES" | "GROUPS";
import { FragmentRefs } from "relay-runtime";
export type EventDetailCapacity_event$data = {
  readonly capacity: number | null | undefined;
  readonly capacityType: EventCapacityType | null | undefined;
  readonly eventSignUps: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly registrations: {
          readonly count: number;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly spotsAvailable: number | null | undefined;
  readonly " $fragmentType": "EventDetailCapacity_event";
};
export type EventDetailCapacity_event$key = {
  readonly " $data"?: EventDetailCapacity_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailCapacity_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailCapacity_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spotsAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacityType",
      "storageKey": null
    },
    {
      "alias": "eventSignUps",
      "args": [
        {
          "kind": "Literal",
          "name": "waitlist",
          "value": false
        }
      ],
      "concreteType": "EventSignUpConnection",
      "kind": "LinkedField",
      "name": "signUps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSignUpEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSignUp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventRegistrationConnection",
                  "kind": "LinkedField",
                  "name": "registrations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "count",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "signUps(waitlist:false)"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "f711802edaf8a83b436062466c1e567a";

export default node;
